<template>
  <div class="plb">
    <div class="plb-legs">
      <div class="plb-left">LEFT LEG</div>
      <div class="plb-right">RIGHT LEG</div>
    </div>
    <div v-for="(key, index) in record " class="plb-info" :class="getOrientation">
      <div class="plb-info-label">{{key.label}}</div>
      <div class="plb-info-values">
        <div class="plb-left-value">{{key.left}}</div>
        <div class="plb-right-value">{{key.right}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import PrintSprinklerData from './PrintSprinklerData.vue';
import { usePrintStore } from '../../../store/PrintStore';

export default {
  name: 'PrintSprinkler',
  components: { PrintSprinklerData },
  props: ['record', 'data', 'title'],
  mounted () {

  },
  computed: {

    getOrientation () {
      return usePrintStore().getOrientation === 'portrait'
        ? 'psd-group-holder-portrait'
        : '';
    },
  },
  methods: {},
};
</script>

<style scoped>
.plb {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  font-size: 10px;
}

.plb-legs {
  display: flex;
}

.plb-left {
  flex: 1;
  text-align: center;
  border-top: 0.5px solid #adadad;
  border-bottom: 0.5px solid #adadad;
  border-right: 0.5px solid #adadad;
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 4px;
}

.plb-right {
  flex: 1;
  text-align: center;
  border-top: 0.5px solid #adadad;
  border-bottom: 0.5px solid #adadad;
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 4px;
}

.plb-info {
  display: flex;
  flex-direction: column;
}

.plb-info-label {
  flex: 1;
  text-align: center;
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 4px;
  font-size: 13px;
}

.plb-info-values {
  display: flex;
  font-size: 13px;
}

.plb-left-value {
  flex: 1;
  text-align: center;
  border-bottom: 0.5px solid #adadad;
  border-right: 0.5px solid #adadad;
  padding-top: 4px;
  padding-bottom: 4px;
  line-height: 1em;
}

.plb-right-value {
  flex: 1;
  text-align: center;
  border-bottom: 0.5px solid #adadad;
  line-height: 1em;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>
